import {
  Module, ActionTree, MutationTree, GetterTree
} from 'vuex';
import { readStorage, writeStorage } from '@/tools/tools';
import { OrderState } from './types';
import { RootState } from '../types';
/**
 * getters
 */
// export const getters: GetterTree<OrderState, RootState> = {
//   addresslist: (state: OrderState) => state.addresslist,
// };

/**
 * mutations
 */
export const mutations: MutationTree<OrderState> = {
  // 确认订单列表
  CONFIRMORDER(state: OrderState, payload: []) {
    state.confirmlist = payload;
    writeStorage('confirmlist', state.confirmlist);
  }
};

/**
 * actions
 */
// export const actions: ActionTree<OrderState, RootState> = {
//   confirmOrder({ commit }, payload: []) {
//     commit('CONFIRMORDER', payload);
//   },
// };
/**
 * state
 */
export const state: OrderState = {
  confirmlist: readStorage('confirmlist') ? readStorage('confirmlist') : []
};
const namespaced: boolean = true;

export const order: Module<OrderState, RootState> = {
  namespaced,
  state,
  mutations
};
